const pureTheme = {
    name: 'Pure',
    colors: {
        primary: '#0284c7',
        primaryDark: '#0369a1',
        primaryDarker: '#075985',
        primaryLight: '#38bdf8',
        primaryLighter: '#7dd3fc',
        primaryLightest: '#e0f2fe',
        secondary: '#14b8a6',
        secondaryDark: '#0d9488',
        secondaryLight: '#5eead4',
        textLight: '#f0f9ff',
        textDark: '#0c4a6e',
        textMedium: '#475569',
        textDisabled: '#94a3b8',
        background: '#f8fafc',
        backgroundLight: '#ffffff',
        white: '#ffffff',
        black: '#000000',
        danger: '#ef4444',
        dangerBg: '#fee2e2',
        borderColor: '#e2e8f0',
        shadowLight: 'rgba(0, 0, 0, 0.05)',
        shadowMedium: 'rgba(0, 0, 0, 0.1)',
        neutralLight: '#f1f5f9',
        neutralMedium: '#cbd5e1',
    },
    fonts: {
        main: 'Manrope, sans-serif',
        headings: 'Manrope, sans-serif',
    },
    spacing: {
        xs: '0.25rem', sm: '0.5rem', md: '1rem', lg: '1.5rem', xl: '2.5rem', xxl: '4rem',
    },
    borderRadius: '0.75rem',
    buttonBorderRadius: '50px',
    shadows: {
        sm: '0 1px 3px 0 rgba(0, 0, 0, 0.07), 0 1px 2px 0 rgba(0, 0, 0, 0.04)',
        md: '0 4px 8px -2px rgba(0, 0, 0, 0.08), 0 2px 4px -2px rgba(0, 0, 0, 0.05)',
        lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.07)',
        xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.07)',
        button: '0 4px 12px -2px rgba(2, 132, 199, 0.4)',
    }
};

const słonecznaPolana = {
    name: 'Słoneczna Polana',
    colors: {
        primary: '#f97316', primaryDark: '#ea580c', primaryDarker: '#c2410c',
        primaryLight: '#fb923c', primaryLighter: '#fdba74', primaryLightest: '#ffedd5',
        secondary: '#84cc16', secondaryDark: '#65a30d', secondaryLight: '#a3e635',
        background: '#fffbeb', backgroundLight: '#fefce8', white: '#ffffff',
        textDark: '#451a03', textMedium: '#78350f', textDisabled: '#9ca3af',
        danger: '#ef4444', dangerBg: '#fee2e2', borderColor: '#fde68a',
        shadowLight: 'rgba(0, 0, 0, 0.05)', shadowMedium: 'rgba(0, 0, 0, 0.1)',
        neutralLight: '#fef3c7', neutralMedium: '#fde68a',
    },
    fonts: { main: "'Comic Neue', cursive", headings: "'Comic Neue', cursive" },
    spacing: { ...pureTheme.spacing }, // **POPRAWKA**
    borderRadius: '1rem', buttonBorderRadius: '50px',
    shadows: { ...pureTheme.shadows }
};

const lesnaKraina = {
    name: 'Leśna Kraina',
    colors: {
        primary: '#22c55e', primaryDark: '#16a34a', primaryDarker: '#15803d',
        primaryLight: '#4ade80', primaryLighter: '#86efac', primaryLightest: '#f0fdf4',
        secondary: '#a16207', secondaryDark: '#854d0e', secondaryLight: '#ca8a04',
        background: '#f5f5f4', backgroundLight: '#fafaf9', white: '#ffffff',
        textDark: '#1c1917', textMedium: '#44403c', textDisabled: '#a8a29e',
        danger: '#ef4444', dangerBg: '#fee2e2', borderColor: '#e7e5e4',
        shadowLight: 'rgba(0, 0, 0, 0.05)', shadowMedium: 'rgba(0, 0, 0, 0.1)',
        neutralLight: '#f5f5f4', neutralMedium: '#e7e5e4',
    },
    fonts: { main: "'Patrick Hand', cursive", headings: "'Patrick Hand', cursive" },
    spacing: { ...pureTheme.spacing }, // **POPRAWKA**
    borderRadius: '0.75rem', buttonBorderRadius: '8px',
    shadows: { ...pureTheme.shadows }
};

const oceanicznaPrzygoda = {
    name: 'Oceaniczna Przygoda',
    colors: {
        primary: '#0ea5e9', primaryDark: '#0284c7', primaryDarker: '#0369a1',
        primaryLight: '#38bdf8', primaryLighter: '#7dd3fc', primaryLightest: '#e0f2fe',
        secondary: '#f59e0b', secondaryDark: '#d97706', secondaryLight: '#fbbf24',
        background: '#f0f9ff', backgroundLight: '#e0f2fe', white: '#ffffff',
        textDark: '#082f49', textMedium: '#075985', textDisabled: '#94a3b8',
        danger: '#ef4444', dangerBg: '#fee2e2', borderColor: '#bae6fd',
        shadowLight: 'rgba(0, 0, 0, 0.05)', shadowMedium: 'rgba(0, 0, 0, 0.1)',
        neutralLight: '#e0f2fe', neutralMedium: '#bae6fd',
    },
    fonts: { main: "'Baloo 2', cursive", headings: "'Baloo 2', cursive" },
    spacing: { ...pureTheme.spacing }, // **POPRAWKA**
    borderRadius: '50px', buttonBorderRadius: '50px',
    shadows: { ...pureTheme.shadows }
};

const kosmicznaPodroz = {
    name: 'Kosmiczna Podróż',
    colors: {
        primary: '#8b5cf6', primaryDark: '#7c3aed', primaryDarker: '#6d28d9',
        primaryLight: '#a78bfa', primaryLighter: '#c4b5fd', primaryLightest: '#ede9fe',
        secondary: '#ec4899', secondaryDark: '#db2777', secondaryLight: '#f472b6',
        background: '#1e1b4b', backgroundLight: '#312e81', white: '#ffffff',
        textDark: '#e0e7ff', textMedium: '#c7d2fe', textDisabled: '#a5b4fc',
        danger: '#ef4444', dangerBg: '#fee2e2', borderColor: '#4338ca',
        shadowLight: 'rgba(0, 0, 0, 0.05)', shadowMedium: 'rgba(0, 0, 0, 0.1)',
        neutralLight: '#312e81', neutralMedium: '#4338ca',
    },
    fonts: { main: "'Space Grotesk', sans-serif", headings: "'Space Grotesk', sans-serif" },
    spacing: { ...pureTheme.spacing }, // **POPRAWKA**
    borderRadius: '0.5rem', buttonBorderRadius: '0.5rem',
    shadows: { ...pureTheme.shadows }
};

const kociZakatek = {
    name: 'Koci Zakątek',
    colors: {
        primary: '#f472b6', primaryDark: '#ec4899', primaryDarker: '#db2777',
        primaryLight: '#f9a8d4', primaryLighter: '#fbcfe8', primaryLightest: '#fce7f3',
        secondary: '#a5b4fc', secondaryDark: '#818cf8', secondaryLight: '#c4b5fd',
        background: '#fff1f2', backgroundLight: '#fff7f9', white: '#ffffff',
        textDark: '#500724', textMedium: '#831843', textDisabled: '#9ca3af',
        danger: '#ef4444', dangerBg: '#fee2e2', borderColor: '#fce7f3',
        shadowLight: 'rgba(0, 0, 0, 0.05)', shadowMedium: 'rgba(0, 0, 0, 0.1)',
        neutralLight: '#fce7f3', neutralMedium: '#fbcfe8',
    },
    fonts: { main: "'Gaegu', cursive", headings: "'Gaegu', cursive" },
    spacing: { ...pureTheme.spacing }, // **POPRAWKA**
    borderRadius: '1rem', buttonBorderRadius: '1rem',
    shadows: { ...pureTheme.shadows }
};

export const themes = {
    pure: pureTheme,
    słonecznaPolana,
    lesnaKraina,
    oceanicznaPrzygoda,
    kosmicznaPodroz,
    kociZakatek,
};